<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Kindgebonden budget bij kinderen tot 18 jaar
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kindgebonden budget is een bijdrage in de kosten voor kinderen tot 18 jaar.
                <div class="space10"></div>

                <b>Je ontvangt de kinderbijslag voor je kind</b><br/>
                De ouder die de kinderbijslag op zijn naam heeft staan bij de Sociale Verzekeringsbank (SVB), heeft
                recht op het kindgebonden budget.
                <div class="space10"></div>

                <b> Het inkomen van jou en je partner is niet te hoog</b><br/>
                Hoe hoog je inkomsten en die van je partner maximaal mogen zijn is niet 1-2-3 te beantwoorden. Hoe hoger
                je inkomen is, hoe minder kindgebonden budget je krijgt. Het kan ook zijn dat je inkomen te hoog is voor
                kindgebonden budget. Daar is geen vaste inkomensgrens voor. <br/>
                Heeft je kind een eigen inkomen? Dan tellen we dat niet mee.<br/>
                <div class="space10"></div>

                <b>Je vermogen is niet te hoog</b><br/>
                De Belastingdienst kijkt ook naar je vermogen en dat van je eventuele toeslagpartner. Heeft je
                minderjarige kind eigen
                vermogen? Dan telt dat óók mee.
                <div class="space10"></div>

                <b>Samenstelling gezin</b><br/>
                Ten slotte is de samenstelling van uw gezin van belang. Zoals hoeveel kinderen je hebt en wat hun
                leeftijd is. Je krijgt namelijk meer kindgebonden budget als je kind 12 of 16 jaar wordt. Als je een
                alleenstaande ouder bent en geen toeslagpartner hebt, krijg je ook meer kindgebonden budget.
                <div class="space10"></div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Zoveel gezinnen, zoveel situaties
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Ben je co-ouders? Heb je een kind van 16 of 17 jaar die niet meer naar school gaat? Woont je in het
                buitenland?
                <div class="space10"></div>
                Lees meer over deze situaties en de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/kindgebonden-budget/voorwaarden/voorwaarden-kindgebonden-budget"
                    target="_blank">voorwaarden</a> die gelden voor het kindgebonden budget.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aanvragen hoeft niet altijd
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Krijg je kinderopvangtoeslag, huurtoeslag of zorgtoeslag? Dan hoef je geen kindgebonden budget aan te
                vragen. Je krijgt vanzelf bericht van de Belastingdienst als je er recht op hebt.<br/>
                <div class="space10"></div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Tot wanneer kan ik kindgebonden budget aanvragen?
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De zorgtoeslag, huurtoeslag en kindgebonden budget kun je nog aanvragen tot en met 31 december in het
                volgende jaar. Je kunt bijvoorbeeld nog zorgtoeslag over 2025 aanvragen tot en met 31 december 2026.
                <div class="space10"></div>
                Heb je nog vóór 2 september van het nieuwe jaar toeslag over het voorgaande jaar aangevraagd? Dan kan
                het een tijdje duren voordat je de toeslag krijgt. Je moet eerst wachten op de definitieve berekening
                van het voorgaande jaar. Binnen 1 week nadat je deze hebt gekregen, maakt de Belastingdienst het bedrag
                in 1 keer aan je over.
                <div class="space10"></div>

                <b>Stopgezette toeslag</b><br/>
                Had je al een toeslag die je hebt stopgezet? En wil je deze opnieuw aanvragen? Dan heb je langer de
                tijd. Je kunt die toeslag nog aanvragen ná 31 december van het volgende jaar. Aanvragen kan dan niet
                meer via online, ook niet via Mijn toeslagen. Schrijf de Belastingdienst een <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/niet_met_ons_eens_toeslagen/verzoek-om-een-beslissing-over-een-toeslag-te-herzien"
                    target="_blank">brief</a> en vraag de Belastingdienst om de ‘stopzetting te herzien’.
                <div class="space10"></div>

                <b>Uitstel voor de aangifte inkomstenbelasting</b><br/>
                Dan heb je meer tijd om toeslag aan te vragen. Want je kunt dan nog zorgtoeslag, huurtoeslag en
                kindgebonden budget aanvragen tot de datum waarop het uitstel afloopt. Dat kan uitstel zijn voor de
                aangifte óf voor de aangifte van je toeslagpartner. Huurtoeslag kun je ook aanvragen zolang een
                medebewoner nog uitstel heeft.
                <div class="space10"></div>


            </div>
        </div>


    </div>

</div>

